import { Middlewares } from "@/app/shared/services/app-router/middlewares";
import Guard from "vue-router-multiguard";

export default [
  {
    path: '/main',
    name: 'Main',
    component: () => import('./views/main.vue'),
    meta: {
      title: 'Первый займ бесплатно',
      wfPage: '652921c910bae02d8870dddc'
    }
  },
  {
    path: '/how-to-get-loan',
    name: 'HowToGetLoan',
    component: () => import('./views/howToGetLoan.vue'),
    meta: {
      title: 'Как получить заём',
      wfPage: '652921c910bae02d8870dddc'
    }
  },
  {
    path: '/how-to-return',
    name: 'HowToReturn',
    component: () => import('./views/howToReturn.vue'),
    meta: {
      title: 'Как вернуть заём',
      wfPage: '652921c910bae02d8870dddc'
    }
  },
  {
    path: '/about-company',
    name: 'AboutCompany',
    component: () => import('./views/aboutCompany.vue'),
    meta: {
      title: 'О компании',
      wfPage: '652921c910bae02d8870dddc'
    }
  },
  {
    path: '/support',
    name: 'Support',
    component: () => import('./views/support.vue'),
    meta: {
      title: 'Центр поддержки',
      wfPage: '652921c910bae02d8870dddc'
    }
  },
  {
    path: '/reviews',
    name: 'Reviews',
    component: () => import('./views/reviews.vue'),
    meta: {
      title: 'Отзывы',
      wfPage: '652921c910bae02d8870dddc'
    }
  },
  {
    path: '/scammers',
    name: 'Scammers',
    component: () => import('./views/scammers.vue'),
    meta: {
      title: 'Мошенники',
      wfPage: '652921c910bae02d8870dddc'
    }
  }
];
